import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'rax-shell-login-failed-page',
    templateUrl: './login-failed-page.component.html',
    imports: [MatButtonModule],
})
export class LoginFailedPage {
    public onTryAgainButtonClick(): void {
        window.location.href = window.location.protocol + '//' + window.location.host;
    }
}
